// Badge de la venta cuya comisión espera a que el cliente active su app — presentación compartida del portal.
import { Badge } from '@/kit';

/** Lo que le falta al cliente para que el vendedor gane la comisión. */
const AWAITING_HINT =
    'Tu cliente aún no activa su app: falta su contraseña, el contrato de la cuenta y su número secreto. La comisión entra a tu corte el día que termine.';

/** Nada si la comisión no espera. `size="xs"` es el chip denso de las filas de tabla. */
export function CommissionAwaitingBadge({
    sale,
    size,
    className,
}: {
    sale: { commissionAwaitingApp?: boolean };
    size?: 'default' | 'xs';
    className?: string;
}) {
    if (!sale.commissionAwaitingApp) return null;
    return (
        <Badge variant="warning" size={size} className={className} title={AWAITING_HINT}>
            Comisión en espera
        </Badge>
    );
}
